import * as yup from 'yup';

export const validationSchema = (cmsData?: any) =>
  yup.object({
    fixedLineNumber: yup
      .string()
      .min(8, cmsData?.validationMinLength || 'Inserire un numero valido')
      .matches(cmsData?.validationRegex || /^0[1-9]([0-9]{6,8})/, 'Inserire un numero valido'),
  });
